module.exports = __webpack_public_path__ + "static/google-app-play-badge-d449378328167c2d2cb1ef7cab70cc4e.png";